import { Button, FormHelperText, TextField, Typography, makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { setCookie } from './tools-common';
import { COMPONENT_NAMES, SCREEN_NAMES, setUserAttribute, trackAnalyticsEvent } from '../../../constants/analyticsMeta';
import { useOnboardingStyles } from '../../onboarding/OnboardingDesignWrapper';

export const useQuestionsStyles = makeStyles((theme) => ({
  qwaFormWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  errorHeading: {
    color: '#C01818',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    paddingBottom: '24px',
  },
  appealMessage: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  appealMessageDescription: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  maxHeaderWidth: {
    maxWidth: '275px',
    margin: 'auto !important',
    paddingTop: '20px',
  },
  questionsWrapper: {
    background: '#F6F7F9',
    padding: '24px 20px',
  },
  questionsWrapperForTools: {
    maxWidth: '390px',
    background: '#F6F7F9',
    padding: '24px 20px',
  },
  questionDescription: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '160%',
  },
  buttonOption: {
    borderRadius: '4.2px',
    border: '1.05px solid #1D3557',
    padding: '16.8px 33.6px',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Source Sans Pro',
    fontSize: '18.9px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '108%',
    textTransform: 'capitalize',
  },
  buttonsWrapper: {
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
    margin: '16px 0px',
  },
  otherRoleTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      gap: 'unset',
    },
  },
  inputTextAlignment: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: 'unset',
    },
  },
  buttonsContainerForToolsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '0px',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      gap: 'unset',
    },
    flexDirection: 'column-reverse',
  },
  submitButton: {
    display: 'flex',
    width: '200px',
    padding: '16.8px 33.6px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10.5px',
    flexShrink: 0,
    borderRadius: '4.2px',
    border: '1.05px solid #1D3557',
    background: '#1D3557',
    color: '#FFFFFF',
    textTransform: 'capitalize',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '18.9px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '108%',
    '&:hover': {
      backgroundColor: '#1D3557',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: '15px',
    },
  },
  secondaryText: {
    color: '#757575',
    fontFamily: 'Poppins',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    textAlign: 'left',
  },
  studentQualityDesc: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '108%',
  },
  updateEmailLink: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    cursor: 'pointer',
    textAlign: 'center',
  },
  termsText: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '12px',
    fontStyle: 'normal',
    fontweight: 400,
  },
  termsLink: {
    fontFamily: '"Source Sans Pro"',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '108%',
    textDecorationLine: 'underline',
    cursor: 'pointer',
  },
}));

export const DescribeQuestion = ({
  setIsDescriberQuestionAnswered,
  isClickedOnLockedOption,
  setIsUseLockedGraceAvailable,
  handleOpen,
  isReachedMaxLimit,
  toolMeta,
}) => {
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [otherValue, setOtherValue] = useState('');

  const handleSelectAnswer = (option) => {
    const isStudent = ['Student or Academia'].includes(option);
    let redirectUser = false;
    setIsDescriberQuestionAnswered(option);
    setCookie('tool_usr_desc', option, true);
    if (isStudent) {
      handleOpen(true);
    } else {
      redirectUser = true;
    }

    trackAnalyticsEvent({
      eventName: 'Job role question answered',
      payload: {
        label: 'Job role question answered',
        component_name: COMPONENT_NAMES.contentai_ai_tools,
        screen_name: SCREEN_NAMES.contentai_ai_tools,
        answer: option,
        ...toolMeta,
      },
    });
    setUserAttribute('role', option);

    if (redirectUser) {
      const UrlToRedirect = isClickedOnLockedOption ? '/get-started?unlock-options' : '/get-started?signup-now';
      localStorage.setItem('previousUrl', window?.parent?.location?.href);
      trackAnalyticsEvent({
        eventName: 'Prompted to Sign Up',
        counterName: 'Prompted to Sign Up',
        isAddCount: true,
        isAnonymousUser: true,
        payload: {
          label: 'Prompted to Sign Up',
          reason: isClickedOnLockedOption ? 'Clicked on Locked Option' : 'Reached your maximum usage limit',
          component_name: COMPONENT_NAMES.contentai_ai_tools,
          screen_name: SCREEN_NAMES.contentai_ai_tools,
          ...toolMeta,
        },
      });
      window.parent.postMessage({ action: 'redirectURL', url: UrlToRedirect }, '*');
    }
  };
  const onboardingStyles = useOnboardingStyles();
  const questionStyles = useQuestionsStyles();

  useEffect(() => {
    trackAnalyticsEvent({
      eventName: 'Job role question shown',
      payload: {
        label: 'Job role question shown',
        component_name: COMPONENT_NAMES.contentai_ai_tools,
        screen_name: SCREEN_NAMES.contentai_ai_tools,
        ...toolMeta,
      },
    });
  }, []);
  return (
    <div>
      {isReachedMaxLimit ? (
        <>
          <Typography className={`${questionStyles.appealMessage} m-15`}>
            Answer a Question to Get Additional Free Usage
          </Typography>
          <Typography className={questionStyles.errorHeading}>You’ve reached your maximum usage limit</Typography>
        </>
      ) : (
        <>
          <Typography className={`${questionStyles.appealMessage} m-15`}>
            Answer the question to access this feature
          </Typography>
          <Typography className={questionStyles.errorHeading}>You have clicked on a locked option</Typography>
        </>
      )}
      <div className={questionStyles.questionsWrapper} style={{ background: '#F6F7F9' }}>
        <Typography variant="h5" component="h2" className={onboardingStyles.heading} style={{ lineHeight: '160%' }}>
          What describes you best?
        </Typography>
        {/* <Typography className={questionStyles.questionDescription}>
            Knowing your role helps us match you with the right sign up options
          </Typography> */}
        <div style={{ margin: '16px 0px 0px 0px', width: '100%' }}>
          <Button
            onClick={() => {
              handleSelectAnswer('Student or Academia');
            }}
            style={{ width: '100%' }}
            className={questionStyles.buttonOption}
          >
            Student or Academia*
          </Button>
          <FormHelperText className={questionStyles.studentQualityDesc}>
            *This selection does not qualify for any special pricing or discounts.
          </FormHelperText>
        </div>
        <div className={questionStyles.buttonsWrapper}>
          {['Business Owner', 'Marketing Professional', 'SEO or Content Marketer'].map((i) => (
            <>
              <Button
                onClick={() => {
                  handleSelectAnswer(i);
                }}
                className={questionStyles.buttonOption}
              >
                {i}
              </Button>
            </>
          ))}
          {!showOtherInput && (
            <Button onClick={() => setShowOtherInput(true)} className={questionStyles.buttonOption}>
              Other (Please type role name in English)
            </Button>
          )}
          {showOtherInput && (
            <div className={questionStyles.otherRoleTextContainer}>
              <TextField
                className={questionStyles.questionDescription}
                placeholder="Type role name in English"
                variant="outlined"
                fullWidth
                value={otherValue}
                onChange={(e) => setOtherValue(e.target.value)}
              />
              <Button
                onClick={() => {
                  if (otherValue) {
                    handleSelectAnswer(otherValue);
                  }
                }}
                className={questionStyles.submitButton}
              >
                Submit
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
